export enum LevelTask {
    FTUX_CARD_MATCH = 'ftux_card_match',
    FTUX_CARD_DECK = 'ftux_card_deck',
    FTUX_BONUS_STREAK = 'ftux_bonus_streak',
    FTUX_BOOSTER_UNDO = 'ftux_booster_undo',
    FTUX_BOOSTER_JOKER = 'ftux_booster_joker',
    FTUX_BOOSTER_TNT = 'ftux_booster_tnt',
    FTUX_BOOSTER_BULLS_EYE = 'ftux_booster_bulls_eye',
    FTUX_BOOSTER_SHUFFLE = 'ftux_booster_shuffle',
    FTUX_SUITCASE = 'ftux_suitcase',
    FTUX_HAZARD_BOMB = 'ftux_hazard_bomb',
    FTUX_GOLD_CARDS = 'ftux_gold_cards',
}
